import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8055e284&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=8055e284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8055e284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8055e284')) {
      api.createRecord('8055e284', component.options)
    } else {
      api.reload('8055e284', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8055e284&scoped=true&", function () {
      api.rerender('8055e284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/purchase-after-sale/index.vue"
export default component.exports